module.exports = __webpack_public_path__ + "img/archive_load.c3b1d617.svg";